import React from 'react';
import { TableCell } from '@mui/material';
import FBOMenuButton from 'ui/theme/components/FBOMenuButton/FBOMenuButton';
import {
  ColumnTypes,
  RenderCustomRowProps,
} from 'ui/components/Table/ItemsTable';
import { DisplayTransferOrder } from 'services/transferOrders';
import { createActionBarOptions } from './consts';
import { FBOTransferOrderStatusBadge } from 'ui/theme/components/FBOTransferOrderStatusBadge';

const TransferOrderRow = React.memo(
  ({ columns, row }: RenderCustomRowProps<DisplayTransferOrder>) => {
    return (
      <>
        {columns.map((column, index) => {
          if (column.type === ColumnTypes.renderByCustomRow && !column.field) {
            // This is the kebab menu column
            return (
              <TableCell
                key={column.field ?? index}
                sx={{ width: column.width }}
              >
                <FBOMenuButton
                  variant="secondary"
                  items={createActionBarOptions()}
                  data-qa={`transfer-order-row-${row.id}-menu`}
                  aria-label="Transfer order actions"
                />
              </TableCell>
            );
          }

          // For regular columns, display the field value
          const fieldValue = column.field ? (row as any)[column.field] : '';

          // Special handling for status column
          if (column.field === 'status') {
            return (
              <TableCell
                key={column.field ?? index}
                sx={{ width: column.width }}
                data-qa={`transfer-order-row-${row.id}-status`}
              >
                <FBOTransferOrderStatusBadge status={row.status} />
              </TableCell>
            );
          }

          return (
            <TableCell key={column.field ?? index} sx={{ width: column.width }}>
              {fieldValue}
            </TableCell>
          );
        })}
      </>
    );
  }
);

TransferOrderRow.displayName = 'TransferOrderRow';

export default TransferOrderRow;
